import * as React from "react";

;
export const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="#100722" {...props}><path d="M17.032 13.083H2v-1.5h15.031C14.645 10.032 12.917 7.365 12.917 4h1.5c0 4.528 3.765 7.57 7.558 7.583H22v1.5c-3.802 0-7.583 3.046-7.583 7.584h-1.5c0-3.366 1.728-6.032 4.115-7.584Z" /></svg>;